import { useState } from "react";

interface MemberGraphFilterProps {
  filterType: string;
  setFilterType: (v: string) => void;
}
const MemberGraphFilter = ({
  filterType,
  setFilterType,
}: MemberGraphFilterProps) => {
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const filter = [
    { name: "일별 통계", value: "daily" },
    { name: "주간 통계", value: "weekly" },
    { name: "월간 통계", value: "monthly" },
  ];
  return (
    <div className="header">
      <div
        className="drop-box"
        onClick={() => {
          setOpenFilter(!openFilter);
        }}
      >
        <div className="value">
          {filter.map((item) => (item.value === filterType ? item.name : ""))}
        </div>
        <img src="/image-web/icon/drop-down.svg" alt="drop-down" />
        {openFilter && (
          <div className="drop-box-wrapper">
            {filter.map((item, index) => (
              <div
                key={index}
                className="item"
                onClick={() => {
                  setFilterType(item.value);
                  setOpenFilter(false);
                }}
              >
                <span>{item.name}</span>
                {item.value === filterType && (
                  <img src="/image-web/tournament/check.svg" alt="check" />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MemberGraphFilter;
